module.exports = __webpack_public_path__ + "static/media/dashboard.1e4ed025.svg";